import { Store } from '../../../store/player/types';

/**
 * Check whether there is a previous recording to go to.
 */
export const hasPreviousRecording = (store: Store): boolean => {
  const { recordingsList, recordingId, getRecordingIndexById } = store.getState();
  if (!recordingsList.length) {
    return false;
  }

  return getRecordingIndexById(recordingId) !== 0;
};
